import { CalendarSearchIcon } from './CalendarSearchIcon';

/**
 * author: GreenTurtwig
 * id 1C61A1FD-56B6-41F1-B677-84D32425225A
 * name calendar-search
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-search.svg
 * tags
 * - Date / Time 
 */
export const EventSearchIcon = CalendarSearchIcon;
export default EventSearchIcon